import customLogger from './custom-logger';
import store from '@/store';

if (typeof window.CustomEvent !== 'function') {
  window.CustomEvent = function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  window.CustomEvent = CustomEvent;
}

export class EventNotifier {
  constructor() {
    this.logger = customLogger('[bCube Event]', 'color:#4ED19C');
    this._lastEvent = null;
    this._history = {};
    this.flags = {};
  }

  get lastEvent() {
    return this._lastEvent;
  }

  set lastEvent(event) {
    this._history[event.type] = this._history[event.type] || [];
    this._history[event.type].push(event);
    this._lastEvent = event;
  }

  emit(eventName, data = {}) {
    const date = new Date();
    const detail = {
      ...data,
      ...store.getters.currentContext,
      timestamp: date.getTime(),
      time: date.toUTCString(),
    };
    this.logger.log(eventName, detail);
    this.lastEvent = new CustomEvent(eventName, { detail });
    document.dispatchEvent(this.lastEvent);

    return this.lastEvent;
  }

  get Board() {
    return {
      DataFetch: this.emit.bind(this, 'Board:Data:Request'),
      DataFetched: this.emit.bind(this, 'Board:Data:Fetched'),
      EditorReady: this.emit.bind(this, 'Board:Editor-Ready'),
      PreviewFailsafe: this.emit.bind(this, 'Board:Preview:Failsafe'),
      PreviewLoad: (data) => {
        let eventName = 'Board:Preview:Updating';
        if (this.flags.UpdatePreview) {
          eventName = 'Board:Update';
        } else if (this.flags.SaveAndUpdatePreview) {
          eventName = 'Board:Save-Update:Updating';
        }
        this.emit(eventName, data);
      },
      PreviewLoaded: (data) => {
        let eventName = 'Board:Preview:Updated';
        if (this.flags.SaveAndUpdatePreview) {
          this.flags.SaveAndUpdatePreview = false;
          eventName = 'Board:Save-Update:Updated';
        } else if (this.flags.UpdatePreview) {
          this.flags.UpdatePreview = false;
          eventName = 'Board:Update:Updated';
        }
        this.emit(eventName, data);
      },
      Publish: this.emit.bind(this, 'Board:Publish:Request'),
      PublishConfirm: this.emit.bind(this, 'Board:Publish:Confirm'),
      Published: this.emit.bind(this, 'Board:Publish:Published'),
      PublishFlowStart: this.emit.bind(this, 'Board:Publish'),
      SaveAndUpdatePreview: (data) => {
        this.flags.SaveAndUpdatePreview = true;
      },
      Save: (data) => {
        let eventName = 'Board:Save';
        if (this.flags.SaveAndUpdatePreview) eventName = 'Board:Save-Update';
        this.emit(eventName, data);
      },
      Saved: (data) => {
        let eventName = 'Board:Save:Saved';
        if (this.flags.SaveAndUpdatePreview) eventName = 'Board:Save-Update:Saved';
        this.emit(eventName, data);
      },
      UnpublishedContentsRequestEnd: this.emit.bind(this, 'Board:Publish:Unpublished-Contents-Request:End'),
      UnpublishedContentsRequestStart: this.emit.bind(this, 'Board:Publish:Unpublished-Contents-Request:Start'),
      UpdatePreview: (data) => {
        this.flags.UpdatePreview = true;
      },
    };
  }

  get Page() {
    return {
      Load: this.emit.bind(this, 'Page-Load'),
      Loaded: this.emit.bind(this, 'Page-Loaded'),
    };
  }
}

const notifier = new EventNotifier();
export default notifier;
